const small = 480;
const medium = 768;
const large = 1024;
const xLarge = 1280;

export const client = {
  isSmallMobile: (clientWidth) => clientWidth <= small,
  isMobile: (clientWidth) => clientWidth <= medium,
  isTablet: (clientWidth) => clientWidth <= large,
  isLaptop: (clientWidth) => clientWidth <= xLarge,
  isDesktop: (clientWidth) => clientWidth > xLarge,
};
